import https from 'https';
import querystring from 'querystring';
const queryify = querystring.stringify;
import Parse from 'parse'

const exported = {};

const baseRequest = {
  method: 'POST',
  hostname: 'api.stripe.com',
  port: null,
  headers: {
    'authorization': 'Bearer rk_live_C3r5wANAQndcx3pv5usfb142000txoHBCc',
    'content-length': '11',
  },
}

exported.newCustomer = (_this, cb) => {
  return new Promise((resolve, reject) => {
    if (typeof _this.get('stripeId') == "undefined") {
      const options = Object.assign(baseRequest, {
        path: '/v1/customers?' + queryify({
          email: _this.get('user').get('email')
        }),
      });
      const req = https.request(options, async (res) => {
        const chunks = []
        res.on('data', (chunk) => chunks.push(chunk))
        await res.on('end', () => {
          _this.set('stripeId', JSON.parse(Buffer.concat(chunks).toString()).id); _this.save()
          resolve(true)
        })
      })
      req.end()
    }
  })
}

exported.charge = (reward) => {
  return new Promise(async (resolve, reject) => {
    const parent = VueInstance.$data.parent
    let defaultTax, results;

    Parse.Config.get().then((config) => {
      defaultTax = config.get("defaultTax");
    }, error => {
      const config = Parse.Config.current();
      defaultTax = config.get("defaultTax") || 0.07;
    })

    let fee = reward.get('cost') * (reward.get('collectionRate') || defaultTax);
    let options = Object.assign(baseRequest, {
      path: '/v1/charges?' + queryify({
        //'transfer_data[amount]': fee < 1 ? 100 : fee * 100,
        amount: reward.get('cost') * 100,
        description: 'Chore Champion Reward',
        statement_descriptor: 'Reward',
        //  'transfer_data[destination]': reward.get('business').get('stripeId'),
        'receipt_email': parent.get('User'),
        'currency': 'usd',
        'customer': parent.get('stripeId')
      }),
    });
    const req = https.request(options, async (res) => {
      const chunks = []
      res.on('data', (chunk) => chunks.push(chunk))
      res.on('end', async () => {
        const result = JSON.parse(Buffer.concat(chunks).toString());
        if (result?.error?.code == 'missing') {
          reject('missing')
        }
        else if (result.outcome.network_status == 'declined_by_network') {
          reject(new Error('Transaction Declined'))
        } else if (result.paid && result.status == 'succeeded') {
          gtag('event', 'purchase', {
            "transaction_id": result.id,
            "value": result.amount / 100,
            "currency": result.currency,
            "shipping": 0,
            "items": [
              {
                "id": reward._getId(),
                "name": reward.get('name'),
                "brand": reward.get('location').get('Business').get('name'),
                "quantity": 1,
                "price": result.amount / 100
              }
            ]
          });
          resolve(await recordOrder(reward, parent, result))
        }
      })
    })
    req.end()
  })
}

function recordOrder(reward, parent, result) {
  return new Promise(async (resolve, reject) => {
    const Order = new Parse.Object.extend('Order')
    const order = new Order()
    order.set('Reward', reward)
    order.set('User', parent.get('user'))
    order.set('Business', await reward.get('location').get('Business'))
    await order.save()
    resolve(result)
  })
}
/**
 * @description Tokenizes cards
 * @return {object}
 * @param {object} card
 */
exported.tokenizeCard = (card) => {
  console.log(card)
  return new Promise((resolve, reject) => {
    const options = Object.assign(baseRequest, {
      path: '/v1/tokens?' + queryify({
        'card[number]': card.number.replace(' ', ''),
        'card[exp_month]': Number(card.exp.split('/')[0]),
        'card[exp_year]': Number(card.exp.split('/')[1]),
        'card[cvc]': card.cvc
      }),
    });
    const req = https.request(options, (res) => {
      const chunks = []
      res.on('data', (chunk) => chunks.push(chunk))
      res.on('end', () => resolve(JSON.parse(Buffer.concat(chunks).toString()).id))
    })
    req.end()
  })
}

exported.addCardToAccount = (token) => {
  return new Promise((resolve, reject) => {
    const stripeId = VueInstance.$data.parent.get('stripeId')
    const options = Object.assign(baseRequest, {
      path: `/v1/customers/${stripeId}?` + queryify({ source: token })
    })
    const req = https.request(options, (res) => {
      const chunks = []
      res.on('data', (chunk) => chunks.push(chunk))
      res.on('end', () => {
        const result = JSON.parse(Buffer.concat(chunks).toString());
        (result.error !== undefined) ? reject(result.error) : resolve(result)
      })
    })
    req.end()
  });
}

exported.getAllCards = () => {
  return new Promise((resolve, reject) => {
    const stripeId = Parse.User.current().val()
    const options = {
      ...baseRequest, ...{
        method: 'GET',
        path: `/v1/customers/${stripeId}/sources?` + queryify({ object: 'card' })
      }
    }
    const req = https.request(options, (res) => {
      const chunks = []
      res.on('data', (chunk) => chunks.push(chunk))
      res.on('end', () => {
        const result = JSON.parse(Buffer.concat(chunks).toString());
        if (result.error !== undefined) reject(result.error)
        else resolve(result)
      })
    })
    req.end()
  });
}

export default exported;
